module.exports = __webpack_public_path__ + "static/img/zy06-card-bg.ee819ad1.png";